import { Container } from 'react-bootstrap';
import './login.css';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../database/firebase';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setemail] = useState('');
  const [pass, setpass] = useState('');
  const[loding,setloding]=useState(false);
  const nav = useNavigate();

  const loginUser = async (email, password) => {
    setloding(true)
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log('User Logged In:', userCredential.user);

      // إرسال state مع التوجيه
      nav('/dashboard-admain', { state: { fromLogin: true } });
    } catch (error) {
      console.error('not exist');
      setloding(false);
    }
  };

  return (
    <div className='loginpage'>
      <Container>
        <div className='login-box'>
          <input value={email} onChange={e => setemail(e.target.value)} type='email' placeholder='email' />
          <input value={pass} onChange={e => setpass(e.target.value)} type='password' placeholder='password' />
          <button onClick={() => (pass !== '' && email !== '' ? loginUser(email, pass) : console.log('is empty'))}>
           {loding ? "Loading.....":"login"}
          </button>
        </div>
      </Container>
    </div>
  );
}
